export const EXPERIENCE = [
  {
    id: "movie-logic",
    company: "Movie Logic",
    role: {
      it: "Lead Unity & Backend Developer (freelance)",
      en: "Lead Unity & Backend Developer (freelance)",
    },
    period: {
      it: "Febbraio 2022 - Attuale",
      en: "February 2022 - Present",
    },
    location: "Roma",
    tasks: {
      it: [
        "Sviluppo frontend Unity di 3 app turistiche Android e iOS per il programma Ecomic del Ministero della Cultura, con supporto AR. Progetto in corso, coperto da NDA. Attualmente in sviluppo.",
        "Sviluppo full-stack di Spectra: piattaforma per film interattivi e gallerie/spazi 3D WebGL. Frontend in React, backend in ASP.NET Core. Aggiornamento corposo in corso.",
        "App mobile e backend di Itinero in ASP.NET Core e PostgreSQL, in produzione dal 2023 e pubblicato su App Store e Google Play. Backend strutturato secondo Clean Architecture e CQRS.",
        "Sviluppo Unity di Natura Prenestina, gioco mobile educativo sulla biodiversità dei Monti Prenestini. Pubblicato su App Store e Google Play.",
        "Sviluppo Unity di Archeo Spoletino, serious game di archeologia per il Comune di Civitella d'Agliano. Pubblicato su App Store e Google Play.",
      ],
      en: [
        "Unity frontend development of 3 tourist apps on Android and iOS for the Ecomic program of the Italian Ministry of Culture, with AR support. Ongoing project, under NDA. Currently in development",
        "Full-stack development of Spectra: a platform for interactive films and 3D WebGL galleries/spaces. Frontend in React, backend in ASP.NET Core. Major update in progress.",
        "Mobile app and backend of Itinero in ASP.NET Core and PostgreSQL, in production since 2023 and published on the App Store and Google Play. Backend built on Clean Architecture and CQRS.",
        "Unity development of Natura Prenestina, an educational mobile game on the biodiversity of the Monti Prenestini. Published on the App Store and Google Play.",
        "Unity development of Archeo Spoletino, an archaeology serious game for the Municipality of Civitella d'Agliano. Published on the App Store and Google Play.",
      ],
    },
  },
  {
    id: "idego",
    company: "Idego",
    role: {
      it: "Unity VR Developer (freelance)",
      en: "Unity VR Developer (freelance)",
    },
    period: {
      it: "Settembre 2025 - Dicembre 2025",
      en: "September 2025 - December 2025",
    },
    location: "Roma",
    tasks: {
      it: [
        "Sviluppo di un'applicazione VR per Oculus che simulava interventi domiciliari per training sanitario.",
        "Implementazione del livello di sincronizzazione tra sistema di animazioni ed eventi di gioco.",
        "Sistema interattivo di domande e risposte con report strutturato delle risposte date.",
      ],
      en: [
        "Development of a VR application for Oculus simulating home-care interventions for healthcare training.",
        "Implementation of the synchronization layer between the animation system and game events.",
        "Interactive Q&A system with a structured report of trainee answers.",
      ],
    },
  },
  {
    id: "digimax",
    company: "Digimax",
    role: {
      it: "Unity Developer (freelance)",
      en: "Unity Developer (freelance)",
    },
    period: {
      it: "Marzo 2023 - Agosto 2024",
      en: "March 2023 - August 2024",
    },
    location: "Roma",
    tasks: {
      it: [
        "Endless runner mobile sviluppato come tie-in promozionale per un film (progetto poi sospeso).",
        "Diorama interattivo in WebGL per la Reggia di Caserta, realizzato in Unity.",
        "Esperienza VR per Oculus dedicata alla Reggia di Caserta.",
      ],
      en: [
        "Mobile endless runner developed as a promotional tie-in for a film (later suspended).",
        "Interactive WebGL diorama for the Royal Palace of Caserta, built in Unity.",
        "VR experience for Oculus dedicated to the Royal Palace of Caserta.",
      ],
    },
  },
  {
    id: "keybiz",
    company: "KeyBiz Srl",
    role: {
      it: "Mid / Senior Unity Developer",
      en: "Mid / Senior Unity Developer",
    },
    period: {
      it: "Novembre 2019 - Novembre 2021",
      en: "November 2019 - November 2021",
    },
    location: "Roma",
    tasks: {
      it: [
        "Sistema di monitoraggio Digital Twin in Unity per la flotta alta velocità di Trenitalia, deployato su touch-table nella sala controllo. Architettura a tre livelli: mappa nazionale georeferenziata, dashboard real-time per comfort e diagnostica, Digital Twin 3D delle anomalie.",
        "Applicazioni Digital Twin e Decision Support System (DSS) in Unity per altri clienti enterprise, tra cui Telecom e settore difesa, distribuite su touch-table.",
        "Web application complementari in React.",
      ],
      en: [
        "Unity Digital Twin monitoring system for Trenitalia's high-speed fleet, deployed on touch-tables in the control room. Three-tier architecture: georeferenced national map, real-time comfort and diagnostics dashboard, 3D Digital Twin of anomalies.",
        "Digital Twin and Decision Support System (DSS) applications in Unity for other enterprise clients, including Telecom and the defence sector, deployed on touch-tables.",
        "Complementary web applications in React.",
      ],
    },
  },
  {
    id: "ambiens-vr",
    company: "Ambiens VR",
    role: {
      it: "Junior Unity Developer",
      en: "Junior Unity Developer",
    },
    period: {
      it: "Agosto 2016 - Ottobre 2019",
      en: "August 2016 - October 2019",
    },
    location: "Roma",
    tasks: {
      it: [
        "Applicazioni VR per Oculus, Valve Index/HTC Vive e Android.",
        "App AR cross-platform per Android e iOS.",
        "Plugin custom per Revit, SketchUp e Unity per studi di architettura.",
        "DLL custom in C# per la creazione di librerie interne riutilizzabili.",
      ],
      en: [
        "VR applications for Oculus, Valve Index/HTC Vive and Android.",
        "Cross-platform AR apps for Android and iOS.",
        "Custom plugins for Revit, SketchUp and Unity targeted at architecture studios.",
        "Custom C# DLLs to build reusable internal libraries.",
      ],
    },
  },
];
